module.exports = __webpack_public_path__ + "files/913ff5449ad7b017703e9ed8da2c4503.png";